<template>
  <section class="section-filters">
    <CampaignsFiltersSelected />
    <div class="filters-list">
      <CampaignsFiltersDropdowns />
      <CampaignsFiltersDate />
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import CampaignsFiltersDropdowns from "./CampaignsFiltersDropdowns.vue";
import CampaignsFiltersDate from "./CampaignsFiltersDate.vue";
import CampaignsFiltersSelected from "./CampaignsFiltersSelected.vue";

@Component({
  components: {
    CampaignsFiltersDropdowns,
    CampaignsFiltersDate,
    CampaignsFiltersSelected,
  },
})
export default class CampaignsFilters extends Vue {
  CampaignsFilter1SelectedOptions = [1, 2];
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-filters {
  .filters-list {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 0 5px;
    margin: 0 -12px;
    @media (max-width: 991px) {
      margin: 0 -8px;
    }
  }

  .dropdown-w {
  }
}
</style>
